/**
 * OwlCarouselNative — Drop-in vanilla JS replacement for Owl Carousel 2.x
 *
 * Usage:
 *   new OwlCarouselNative('.owl-carousel', { loop: true, margin: 20, ... });
 *
 * Also registers a jQuery plugin shim so existing
 *   jQuery('.owl-carousel').owlCarousel({...})
 * calls work without changes.
 */
(function () {
  'use strict';

  function OwlCarouselNative(selector, options) {
    var el = typeof selector === 'string' ? document.querySelector(selector) : selector;
    if (!el) return;

    var defaults = {
      items: 3,
      loop: false,
      margin: 0,
      nav: false,
      dots: false,
      autoplay: false,
      autoplayTimeout: 3000,
      autoplayHoverPause: true,
      responsive: null,
      responsiveClass: false,
      dragEndSpeed: 300,
      padding: 0
    };

    var o = {};
    for (var k in defaults) o[k] = defaults[k];
    for (var k2 in options) o[k2] = options[k2];

    // state
    var stage, stageOuter, navContainer, dotsContainer;
    var slides = [];
    var clonesBefore = [];
    var clonesAfter = [];
    var currentIndex = 0;
    var isAnimating = false;
    var autoplayTimer = null;
    var dragStartX = 0;
    var dragCurrentX = 0;
    var isDragging = false;
    var translateX = 0;

    // helpers
    function getResponsiveSettings() {
      if (!o.responsive) {
        return {
          items: o.items,
          margin: o.margin,
          autoplay: o.autoplay,
          loop: o.loop,
          padding: o.padding
        };
      }

      var w = window.innerWidth;
      var match = null;
      var breakpoints = Object.keys(o.responsive).map(Number).sort(function (a, b) {
        return a - b;
      });

      for (var i = 0; i < breakpoints.length; i++) {
        if (w >= breakpoints[i]) {
          match = o.responsive[breakpoints[i]];
        }
      }

      return {
        items: match && match.items != null ? match.items : o.items,
        margin: match && match.margin != null ? match.margin : o.margin,
        autoplay: match && match.autoplay != null ? match.autoplay : o.autoplay,
        loop: match && match.loop != null ? match.loop : o.loop,
        padding: match && match.padding != null ? match.padding : o.padding
      };
    }

    function getResponsiveItems() {
      return getResponsiveSettings().items;
    }

    function getResponsiveMargin() {
      return getResponsiveSettings().margin;
    }

    function getResponsiveAutoplay() {
      return getResponsiveSettings().autoplay;
    }

    function getResponsiveLoop() {
      return getResponsiveSettings().loop;
    }

    function getResponsivePadding() {
      return getResponsiveSettings().padding;
    }

    function totalSlides() {
      return slides.length;
    }

    function canSlide() {
      return totalSlides() > getResponsiveItems();
    }

    function slideWidth() {
      var margin = getResponsiveMargin();
      var perView = getResponsiveItems();
      var padding = getResponsivePadding();
      var containerW = stageOuter.offsetWidth;

      return (containerW - padding * 2 - margin * (perView - 1)) / perView;
    }

    function maxIndex() {
      var perView = getResponsiveItems();
      var max = totalSlides() - perView;
      return max < 0 ? 0 : max;
    }

    function setTranslate(x, animate) {
      translateX = x;
      stage.style.transition = animate ? 'transform ' + o.dragEndSpeed + 'ms ease' : 'none';
      stage.style.transform = 'translate3d(' + x + 'px, 0, 0)';
    }

    function getOffsetForIndex(idx) {
      var margin = getResponsiveMargin();
      var sw = slideWidth();
      return -(idx * (sw + margin));
    }

    function updateControlsVisibility() {
      var shouldHideControls = !canSlide();

      if (navContainer) {
        navContainer.style.display = (o.nav && !shouldHideControls) ? '' : 'none';
      }

      if (dotsContainer) {
        dotsContainer.style.display = (o.dots && !shouldHideControls) ? '' : 'none';
      }
    }

    // build DOM
    function build() {
      el.classList.add('owl-carousel', 'owl-theme', 'owl-loaded');

      var children = Array.prototype.slice.call(el.children);
      stageOuter = document.createElement('div');
      stageOuter.className = 'owl-stage-outer';
      stage = document.createElement('div');
      stage.className = 'owl-stage';

      children.forEach(function (child) {
        var item = document.createElement('div');
        item.className = 'owl-item';
        item.appendChild(child);
        stage.appendChild(item);
        slides.push(item);
      });

      stageOuter.appendChild(stage);
      el.innerHTML = '';
      el.appendChild(stageOuter);

      if (o.loop && canSlide()) buildClones();
      if (o.nav) buildNav();
      if (o.dots) buildDots();

      layout();
      updateControlsVisibility();
      bindEvents();

      if (getResponsiveAutoplay() && canSlide()) {
        startAutoplay();
      }
    }

    function buildClones() {
      if (!o.loop || !canSlide()) return;

      var perView = getResponsiveItems();
      var count = Math.min(perView, totalSlides());

      for (var i = 0; i < count; i++) {
        var c = slides[i].cloneNode(true);
        c.classList.add('cloned');
        stage.appendChild(c);
        clonesAfter.push(c);
      }

      for (var j = totalSlides() - 1; j >= totalSlides() - count; j--) {
        var c2 = slides[j].cloneNode(true);
        c2.classList.add('cloned');
        stage.insertBefore(c2, stage.firstChild);
        clonesBefore.push(c2);
      }
    }

    function buildNav() {
      navContainer = document.createElement('div');
      navContainer.className = 'owl-nav';

      var prev = document.createElement('button');
      prev.type = 'button';
      prev.className = 'owl-prev';
      prev.setAttribute('aria-label', 'Previous slide');
      prev.innerHTML = '<span aria-label="Previous">&lsaquo;</span>';
      prev.addEventListener('click', function (e) {
        e.preventDefault();
        goPrev();
      });

      var next = document.createElement('button');
      next.type = 'button';
      next.className = 'owl-next';
      next.setAttribute('aria-label', 'Next slide');
      next.innerHTML = '<span aria-label="Next">&rsaquo;</span>';
      next.addEventListener('click', function (e) {
        e.preventDefault();
        goNext();
      });

      navContainer.appendChild(prev);
      navContainer.appendChild(next);
      el.appendChild(navContainer);
    }

    function buildDots() {
      dotsContainer = document.createElement('div');
      dotsContainer.className = 'owl-dots';
      el.appendChild(dotsContainer);
      renderDots();
    }

    function renderDots() {
      if (!dotsContainer) return;

      dotsContainer.innerHTML = '';

      if (!canSlide()) return;

      var perView = getResponsiveItems();
      var pages = Math.ceil(totalSlides() / perView);

      for (var i = 0; i < pages; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'owl-dot' + (i === Math.floor(currentIndex / perView) ? ' active' : '');
        dot.setAttribute('aria-label', 'Page ' + (i + 1));
        dot.innerHTML = '<span></span>';

        (function (idx) {
          dot.addEventListener('click', function () {
            goTo(idx * perView);
          });
        })(i);

        dotsContainer.appendChild(dot);
      }
    }

    // layout
    function layout() {
      var perView = getResponsiveItems();
      var margin = getResponsiveMargin();
      var sw = slideWidth();
      var padding = getResponsivePadding();

      var allItems = stage.querySelectorAll('.owl-item');
      for (var i = 0; i < allItems.length; i++) {
        allItems[i].style.width = sw + 'px';
        allItems[i].style.marginRight = margin + 'px';
      }

      stageOuter.style.paddingLeft = padding + 'px';
      stageOuter.style.paddingRight = padding + 'px';

      var totalItems = allItems.length;
      stage.style.width = (totalItems * (sw + margin)) + 'px';

      if (getResponsiveLoop() && clonesBefore.length > 0 && canSlide()) {
        var offset = clonesBefore.length * (sw + margin);
        setTranslate(-offset + getOffsetForIndex(currentIndex), false);
      } else {
        currentIndex = Math.min(currentIndex, maxIndex());
        setTranslate(getOffsetForIndex(currentIndex), false);
      }

      updateActiveClasses();
      updateControlsVisibility();
    }

    function updateActiveClasses() {
      var allItems = stage.querySelectorAll('.owl-item');
      var perView = getResponsiveItems();
      var startReal = (getResponsiveLoop() && clonesBefore.length > 0 && canSlide())
        ? clonesBefore.length + currentIndex
        : currentIndex;

      for (var i = 0; i < allItems.length; i++) {
        allItems[i].classList.remove('active');
      }

      for (var j = startReal; j < startReal + perView && j < allItems.length; j++) {
        allItems[j].classList.add('active');
      }

      renderDots();
    }

    // navigation
    function goTo(idx, animate) {
      if (isAnimating || !canSlide()) return;

      var loop = getResponsiveLoop();

      if (!loop) {
        idx = Math.max(0, Math.min(idx, maxIndex()));
      }

      currentIndex = idx;

      if (loop && clonesBefore.length > 0) {
        var margin = getResponsiveMargin();
        var sw = slideWidth();
        var offset = clonesBefore.length * (sw + margin);
        var target = -offset + getOffsetForIndex(currentIndex);

        if (animate !== false) {
          isAnimating = true;
          setTranslate(target, true);

          stage.addEventListener('transitionend', function handler() {
            stage.removeEventListener('transitionend', handler);
            isAnimating = false;

            if (currentIndex >= totalSlides()) {
              currentIndex = 0;
              setTranslate(-offset, false);
            } else if (currentIndex < 0) {
              currentIndex = totalSlides() - 1;
              setTranslate(-offset + getOffsetForIndex(currentIndex), false);
            }

            updateActiveClasses();
          });
        } else {
          setTranslate(target, false);
        }
      } else {
        if (animate !== false) {
          isAnimating = true;
          setTranslate(getOffsetForIndex(currentIndex), true);

          stage.addEventListener('transitionend', function handler2() {
            stage.removeEventListener('transitionend', handler2);
            isAnimating = false;
            updateActiveClasses();
          });
        } else {
          setTranslate(getOffsetForIndex(currentIndex), false);
        }
      }

      updateActiveClasses();
      restartAutoplay();
    }

    function goNext() {
      if (!canSlide()) return;

      var loop = getResponsiveLoop();
      if (loop) {
        goTo(currentIndex + 1);
      } else {
        goTo(Math.min(currentIndex + 1, maxIndex()));
      }
    }

    function goPrev() {
      if (!canSlide()) return;

      var loop = getResponsiveLoop();
      if (loop) {
        goTo(currentIndex - 1);
      } else {
        goTo(Math.max(currentIndex - 1, 0));
      }
    }

    // autoplay
    function startAutoplay() {
      stopAutoplay();

      if (!canSlide()) return;

      autoplayTimer = setInterval(function () {
        goNext();
      }, o.autoplayTimeout);
    }

    function stopAutoplay() {
      if (autoplayTimer) {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    function restartAutoplay() {
      if (getResponsiveAutoplay() && canSlide()) {
        startAutoplay();
      } else {
        stopAutoplay();
      }
    }

    // drag / touch
    function onDragStart(e) {
      if (isAnimating || !canSlide()) return;

      isDragging = true;
      dragStartX = e.type === 'touchstart' ? e.touches[0].clientX : e.clientX;
      dragCurrentX = dragStartX;
      stage.style.transition = 'none';

      if (o.autoplayHoverPause) stopAutoplay();
    }

    function onDragMove(e) {
      if (!isDragging || !canSlide()) return;

      dragCurrentX = e.type === 'touchmove' ? e.touches[0].clientX : e.clientX;
      var diff = dragCurrentX - dragStartX;

      var margin = getResponsiveMargin();
      var sw = slideWidth();
      var base;

      if (getResponsiveLoop() && clonesBefore.length > 0) {
        var offset = clonesBefore.length * (sw + margin);
        base = -offset + getOffsetForIndex(currentIndex);
      } else {
        base = getOffsetForIndex(currentIndex);
      }

      stage.style.transform = 'translate3d(' + (base + diff) + 'px, 0, 0)';
    }

    function onDragEnd() {
      if (!isDragging || !canSlide()) return;

      isDragging = false;
      var diff = dragCurrentX - dragStartX;
      var threshold = slideWidth() * 0.2;

      if (diff < -threshold) {
        goNext();
      } else if (diff > threshold) {
        goPrev();
      } else {
        goTo(currentIndex);
      }

      restartAutoplay();
    }

    // events
    function bindEvents() {
      stageOuter.addEventListener('touchstart', onDragStart, { passive: true });
      stageOuter.addEventListener('touchmove', onDragMove, { passive: true });
      stageOuter.addEventListener('touchend', onDragEnd);

      stageOuter.addEventListener('mousedown', onDragStart);
      document.addEventListener('mousemove', onDragMove);
      document.addEventListener('mouseup', onDragEnd);

      stageOuter.addEventListener('dragstart', function (e) {
        e.preventDefault();
      });

      if (o.autoplayHoverPause) {
        el.addEventListener('mouseenter', stopAutoplay);
        el.addEventListener('mouseleave', function () {
          if (getResponsiveAutoplay() && canSlide()) {
            startAutoplay();
          }
        });
      }

      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          rebuildClones();
          currentIndex = Math.min(currentIndex, maxIndex());
          layout();

          if (getResponsiveAutoplay() && canSlide()) {
            restartAutoplay();
          } else {
            stopAutoplay();
          }
        }, 150);
      });
    }

    function rebuildClones() {
      clonesBefore.forEach(function (c) {
        if (c.parentNode) c.parentNode.removeChild(c);
      });
      clonesAfter.forEach(function (c) {
        if (c.parentNode) c.parentNode.removeChild(c);
      });

      clonesBefore = [];
      clonesAfter = [];

      if (!getResponsiveLoop() || !canSlide()) return;

      var perView = getResponsiveItems();
      var count = Math.min(perView, totalSlides());

      for (var i = 0; i < count; i++) {
        var c = slides[i].cloneNode(true);
        c.classList.add('cloned');
        stage.appendChild(c);
        clonesAfter.push(c);
      }

      for (var j = totalSlides() - 1; j >= totalSlides() - count; j--) {
        var c2 = slides[j].cloneNode(true);
        c2.classList.add('cloned');
        stage.insertBefore(c2, stage.firstChild);
        clonesBefore.push(c2);
      }
    }

    // public API
    this.next = goNext;
    this.prev = goPrev;
    this.goTo = goTo;
    this.destroy = function () {
      stopAutoplay();
      el.innerHTML = '';
      slides.forEach(function (s) {
        el.appendChild(s.firstElementChild);
      });
      el.classList.remove('owl-loaded');
    };

    // init
    build();
  }

  // expose globally
  window.OwlCarouselNative = OwlCarouselNative;

  // jQuery shim
  if (typeof jQuery !== 'undefined') {
    jQuery.fn.owlCarousel = function (options) {
      return this.each(function () {
        if (!this._owlNative) {
          this._owlNative = new OwlCarouselNative(this, options);
        }
      });
    };
  }
})();